module.exports = __webpack_public_path__ + "img/30.a44ef1c5.jpg";